import React from "react";
import styles from "./index.module.scss";
import image from "../../../../assets/blocks-new.jpg";
import {useNavigate} from "react-router-dom";
import {Popover} from "antd";
import clsx from "clsx";

export default function Schema() {
 
  const navigate = useNavigate();
 

  const onClick = (blockNumber) => () => {
      navigate(`/main/floor-selector?block=${blockNumber}`);
  };
 

  return (
      <svg width="4096" height="2729" viewBox="0 0 4096 2729" fill="none" xmlns="http://www.w3.org/2000/svg"
           className={styles.svg} xmlnsXlink="http://www.w3.org/1999/xlink">
          <rect width="4096" height="2729" fill="url(#pattern0_87_18)"/>
          <Popover placement={"top"} content={1}>
              <path d="M801 162H1396V397V540.5H801V697.5H534.5V223H801V162Z" fill="#FF1010" fillOpacity="0.33" stroke="white" className={clsx(styles.block, styles.block1)} onClick={onClick(1)}/>
          </Popover>
          <Popover placement={"top"} content={2}>
              <path d="M519.5 744.5H899V1344H519.5V744.5Z" fill="#FF1010" fillOpacity="0.33" stroke="white" className={clsx(styles.block, styles.block2)} onClick={onClick(2)}/>
          </Popover>
          <Popover placement={"top"} content={3}>
              <path d="M520 1346H898V1934H520V1346Z" fill="#FF1010" fillOpacity="0.33" stroke="white" className={clsx(styles.block, styles.block3)} onClick={onClick(3)}/>
          </Popover>
          <Popover placement={"top"} content={4}>
              <path d="M521 1935H897.5V2523.5H521V1935Z" fill="#FF1010" fillOpacity="0.33" stroke="white" className={clsx(styles.block, styles.block4)} onClick={onClick(4)}/>
          </Popover>
          <defs>
              <pattern id="pattern0_87_18" patternContentUnits="objectBoundingBox" width="1" height="1">
                  <use xlinkHref="#image0_87_18" transform="scale(0.000244141 0.000366435)"/>
              </pattern>
              <image id="image0_87_18" width="4096" height="2729" preserveAspectRatio="none" xlinkHref={image}/>
          </defs>
      </svg>


  );
}
